import React from 'react';
import {
  arrayOf, object, shape, string, number, bool,
} from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import Installments from '../../../Installments';

const PaymentResultInstallment = ({ installments, billingSchedule }) => {
  if (installments.length === 0) {
    return null;
  }

  return <div className="payment-result__content-info__installments">
    <div className="installments__title">
      {billingSchedule.autoBilling
        ? <Locale id="checkout.lib.components.text.scheduleOfAutomatic" />
        : <Locale id="checkout.lib.components.text.scheduleOfManual" />}
    </div>
    <div className="installments__subTitle"><Locale id="checkout.lib.components.text.theBalanceOfThisOrder" /></div>
    <Installments installmentList={installments}/>
  </div>;
};

PaymentResultInstallment.propTypes = {
  installments: arrayOf(shape({
    remainingBalance: number,
    currencyCode: string,
    dueDate: object,
  })),
  billingSchedule: shape({
    autoBilling: bool,
  }),
};

PaymentResultInstallment.defaultProps = {
  installments: [],
  billingSchedule: {},
};

export default PaymentResultInstallment;
